import { render } from "./FaqModal.vue?vue&type=template&id=6aa26b89&scoped=true"
import script from "./FaqModal.vue?vue&type=script&lang=js"
export * from "./FaqModal.vue?vue&type=script&lang=js"

import "./FaqModal.vue?vue&type=style&index=0&id=6aa26b89&scoped=true&lang=css"

import exportComponent from "/Volumes/SSD/jenkins/workspace/Walk Online Mobile/Walk Online Admin/Walk Online Admin Prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa26b89"]])

export default __exports__